import { memo, useEffect, useState } from "react";
import ShareIcon from "core/assets/icons/recipe/share-icon.svg";
import { config } from "core/config/app";
import CDialog from "../CDialog";
import Icon from 'core/assets/icons';
import { TypeShareSns } from "core/constants";
import { _t } from "core/language";
import { useSelector } from "react-redux";
import CDialogShareSns from "./CDialogShareSns";
import { mapTermHostHompage, mapTermPrefix } from "../CShareCommunity";

interface ShareComponentProps {
  id: number;
  title: string;
  urlImg?: string;
  recipeRequestId?: any;
  post?: any;
}

const ShareComponent = ({ id, title, urlImg, recipeRequestId, post }: ShareComponentProps) => {
  const clientSetting = useSelector((state: any) => state.AppSettings);
  console.log(clientSetting, 'ShareComponent', id, title, urlImg);
  const [stateDialogShareSns, setStateDialogShareSns] = useState(false);
  const [isShowTextCopied, setIsShowTextCopied] = useState(false);
  const langCurrent = (window as any)._APP_LANG

  const [isShowShare, setIsShowShare] = useState(false);

  useEffect(() => {
    const setting = clientSetting;
    if (setting && setting.data?.configs && setting.data?.configs?.share_enabled) {
      setIsShowShare(setting.data?.configs?.share_enabled);
    } else {
      setIsShowShare(false);
    }
  }, [clientSetting]);

  let link = ``;
  const hostHome = `${mapTermHostHompage(config.homepageUrl)}`;
  let linkShareSns = hostHome;
  let envApp = 'dev';
  const dataShareSns = ``;
  const paramsShare = (envApp: any) => {
    const paramUrlShare = `recipeId=${id}&requestId=${recipeRequestId}&v=${config.apiVersion}&lang=${langCurrent}&data=${dataShareSns}&ev=${envApp}&va=${mapTermPrefix(config.basename)}`;
    const encodedString = btoa(unescape(encodeURIComponent(paramUrlShare))); // Mã hóa
    return encodedString;
  }
  if (config.environment === 'development') {
    linkShareSns = `${hostHome}/share.php?token=${paramsShare(envApp)}`;
    link = linkShareSns;
  }
  if (config.environment === 'production') {
    envApp = 'pro';
    linkShareSns = `${hostHome}/share.php?token=${paramsShare(envApp)}`;
    link = linkShareSns;
  }

  const shareMessage: string = `${title}\n${linkShareSns}`;
  const shareMessageSns: string = `${title}\n${linkShareSns}`;

  const handleShare = () => {
    if (!isShowShare) {
      handleShareDevice()
      return
    }
    setStateDialogShareSns(true);
  };

  const handleShareSocial = (type: any) => {
    // (window as any).location.replace(linkShareSns);
    let textShare = shareMessageSns;
    // if(type === TypeShareSns.KAKAOTALK) {
    textShare = `${_t('recipe.text_share_sns', { recipe_name: title || '' })}\n${linkShareSns}`;
    // }
    const dataShareSns = {
      content: textShare,
      url: linkShareSns,
      urlImg: urlImg
    };
    console.log(type, dataShareSns, 'handleShareSocial', shareMessageSns);
    (window as any).webViewRequestShareSns(type, dataShareSns);
    setTimeout(() => {
      setStateDialogShareSns(false);
    }, 1000);
  };

  const handleShareDevice = () => {
    // window.open(`${link}`, "_blank");
    (window as any).webViewRequestShare(shareMessage);
    setStateDialogShareSns(false);
  };

  const handleCopy = (value: any) => {
    const valueCopy = value
    const input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', valueCopy);
    document.body.appendChild(input);
    input.setSelectionRange(0, 9999); // Select all text in input
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    setIsShowTextCopied(true);
    setTimeout(() => {
      setIsShowTextCopied(false)
    }, 3000);
  }

  return (<>
    <CDialogShareSns
      onClose={() => { setStateDialogShareSns(false) }}
      isOpen={stateDialogShareSns}
      id={id}
      title={title}
      urlImg={urlImg || Icon.NoImage}
      link={link}
      iconShare={ShareIcon}
      post={post}
      postType={'recipe'}
    />
    <div className="flex hidden">
      <img onClick={handleShare} src={ShareIcon} alt="" />
      <CDialog
        open={stateDialogShareSns}
        closeModal={() => { setStateDialogShareSns(false) }}
        classNamechildren={'pb-[20px]'}
        isButton={false}
      >
        <div>
          <h3 className="text-[14px] font-medium text-[#111111]">{_t('recipe.title_share_sns')}</h3>
          <div className="py-[20px]">
            <div className="flex gap-x-2.5 justify-center">
              <button onClick={() => handleShareSocial(TypeShareSns.IN_APP)} className="gap-y-2 hidden">
                <img
                  src={Icon.InAppShare}
                  alt={'InAppShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button>
              <button onClick={() => handleShareSocial(TypeShareSns.FACEBOOK)} className="gap-y-2">
                <img
                  src={Icon.FbShare}
                  alt={'FbShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button>
              {/* <button onClick={() => handleShareSocial(TypeShareSns.INSTAGRAM)} className="gap-y-2">
                <img
                  src={Icon.InstagramShare}
                  alt={'InstagramShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button> */}
              <button onClick={() => handleShareSocial(TypeShareSns.KAKAOTALK)} className="gap-y-2">
                <img
                  src={Icon.KakaoShare}
                  alt={'KakaoShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button>
              <button onClick={() => handleShareDevice()} className="gap-y-2">
                <img
                  src={Icon.MoreShare}
                  alt={'MoreShare'}
                  className="object-contain shrink-0 aspect-square w-[50px]"
                />
              </button>
            </div>
          </div>
          <div className="bg-[#f8f8f8] rounded-[4px]">
            <div className={`flex justify-between pl-[10px] items-center h-[40px] pr-[20px] relative ${isShowTextCopied ? ' pl-[5px] pr-[12px]' : ''}`}>
              <div className={`flex items-center w-[calc(100%-65px)] ${isShowTextCopied ? ' w-[calc(100%-78px)]' : ''}`}>
                <img
                  src={Icon.CopyShare}
                  alt={'CopyShare'}
                  className="object-contain shrink-0 aspect-square w-[18px] h-[18px] mr-[5px]"
                />
                <label htmlFor="" className="text-[12px] whitespace-nowrap overflow-hidden">{linkShareSns}</label>
              </div>
              {/* {isShowTextCopied ? <div className="px-[5px] absolute top-[-35px] h-[30px] text-[10px] rounded-[6px] bg-[#8080802e] right-[12px] flex items-center">{_t("recipe.copy")}</div> : ''} */}
              <label htmlFor="" className={`text-[12px] text-[#999999] font-medium whitespace-nowrap ${isShowTextCopied ? ' !text-[#2FCF78]' : ''}`} onClick={() => handleCopy(linkShareSns)}>{isShowTextCopied ? _t('recipe.copied') : _t('recipe.copy')}</label>
            </div>
          </div>
        </div>
      </CDialog>
    </div>
  </>
  );
};

export default memo(ShareComponent);
